module.exports = __webpack_public_path__ + "static/media/smm.39caef2c.jpg";